import { PaletteMode } from '@mui/material';
import { chronoDefinedDarkTokens, chronoDefinedLightTokens, unitySemanticLightColorTokens } from '@/theme/unityTokens';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, red } from '../colors';

export const errorColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unitySemanticLightColorTokens['--semantic-data-informative-negative'],
          highContrast: chronoDefinedLightTokens['--data-informative-negative-high-contrast'],
          lowContrast: chronoDefinedLightTokens['--data-informative-negative-low-contrast'],
        }
      : {
          main: chronoDefinedDarkTokens['--data-informative-negative'],
          highContrast: chronoDefinedDarkTokens['--data-informative-negative-high-contrast'],
          lowContrast: chronoDefinedDarkTokens['--data-informative-negative-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: red[600],
        highContrast: red[700],
        lowContrast: red[100],
      }
    : {
        main: red[500],
        highContrast: red[100],
        lowContrast: red[800],
      };
};
